module.exports = __webpack_public_path__ + "media/assets/images/blog/sysadm_servers-small-73fab842f22536a25b95af84f1d8e2b9.jpeg";